import { Tab } from 'types'

export const payablesTabs: Tab[] = [
  { id: 'to-pay', label: 'To Pay' },
  { id: 'paid', label: 'Paid' },
]

export const EXPENSE_CATEGORIES = [
  'Maintenance',
  'Fuel',
  'Insurance',
  'Telecom',
  'Equipment',
  'Office',
  'Software',
  'TollsAndPermits',
  'ProfessionalServices',
  'Meals',
  'Travel',
  'Entertainment',
  'Parking',
  'TruckAndTrailerWash',
  'Other',
] as const

export const EXPENSE_RELATED_TO = [
  'Truck',
  'Trailer',
  'Driver',
  'Order',
  'Trip',
  'Customer',
  'General',
] as const

export const categoryLabel = (value: string) => {
  switch (value) {
    case 'TollsAndPermits':
      return 'Tolls & Permits'
    case 'ProfessionalServices':
      return 'Professional Services'
    case 'TruckAndTrailerWash':
      return 'Truck & Trailer Wash'
    default:
      return value
  }
}
